// extracted by mini-css-extract-plugin
module.exports = {"public-profile":"CompanyInfoDashboard_public-profile__3hAsy","view-profile":"CompanyInfoDashboard_view-profile__odWEP"};